import DateFormatter from "@/utils/DateFormatter";
import Model from "@/models/Model";
import getDefaultRight from './getDefaultRight.js';

export default class Right extends Model {

  constructor(data = getDefaultRight()) {
    super(data);
    this.revoke = String(this.revoke) === "true";
  }

  get id() {
    return this.spnr || this.isrc;
  }

  get rowNumber() {
    return this.rownumber;
  }

  get type() {
    return this.ityp;
  }

  set type(v) {
    this.ityp = v;
  }

  get duration() {
    return this.dur;
  }

  set duration(v) {
    this.dur = v;
  }

  // get isrc() {
  //   return this.isrc;
  // }

  // set isrc(v) {
  //   this.isrc = v;
  // }

  get artistName() {
    return this.arso;
  }

  set artistName(v) {
    this.arso = v;
  }

  get title() {
    return this.tit;
  }

  set title(v) {
    this.tit = v;
  }

  get countryCode() {
    return this.lndi;
  }

  set countryCode(v) {
    this.lndi = v === undefined ? null : v;
  }

  get companyCountryCode() {
    return this.lndcr;
  }

  set companyCountryCode(v) {
    this.lndcr = v === undefined ? null : v;
  }

  get secondaryCountryCode() {
    return this.lndsi;
  }

  set secondaryCountryCode(v) {
    this.lndsi = v === undefined ? null : v;
  }

  get year() {
    return this.ccyy;
  }

  set year(v) {
    this.ccyy = v;
  }

  get claimStartDate() {
    return [0, null].includes(this.fdat) ? '1970-01-01'  : DateFormatter.numericToISO(this.fdat);
  }

  set claimStartDate(v) {
    this.fdat = v === '1970-01-01' ? null : DateFormatter.isoToNumeric(v);
  }

  get claimEndDate() {
    return [0, null].includes(this.tdat) ? '1970-01-01' : DateFormatter.numericToISO(this.tdat);
  }

  set claimEndDate(v) {
    this.tdat = v === '1970-01-01' ? null : DateFormatter.isoToNumeric(v);
  }

  get labelName() {
    return this.labl;
  }

  set labelName(v) {
    this.labl = v;
  }

  get status() {
    return this.right_action;
  }

  set status(v) {
    this.right_action = v;
  }

  get version() {
    return this.vers;
  }

  set version(v) {
    this.vers = v;
  }

  get composer() {
    return this.comp;
  }

  set composer(v) {
    this.comp = v;
  }

  get internationalCollection() {
    return this.intc === 'N';
  }

  set internationalCollection(v) {
    this.intc = v ? 'N' : '';
  }

  get noEnd() {
    return String(this.tdat) === '21491231';
  }

  set noEnd(value) {
    if (value) {
      this.tdat = '21491231';
    } else {
      this.tdat = DateFormatter.dateToNumeric(new Date());
    }
  }

  get externalId() {
    return this.exid;
  }

  set externalId(v) {
    this.exid = v;
  }

  get searchTerms() {
    return this.grp;
  }

  set searchTerms(v) {
    this.grp = v;
  }

  get rdxId() {
    return this.rdxid;
  }

  set rdxId(v) {
    this.rdxid = v;
  }

  get isEditable() {
    return this.editable;
  }

  set isEditable(v) {
    this.editable = v;
  }


}